

// Payment Plans
export const getPlans = () => ({
  type: 'GET_PLANS'
});

// Get Current Plan
export const getCurrentPlan = () => ({
  type: 'GET_CURRENT_PLAN'
});

// Get Credit Packages
export const getCreditPackages = () => ({
  type: 'GET_CREDIT_PACKAGES'
});

// Client Portal Session
export const createPortalSession = () => ({
  type: 'CREATE_PORTAL_SESSION'
});

// Client Portal Session
export const createCheckoutSession = (payload) => ({
  payload,
  type: 'CREATE_CHECKOUT_SESSION',
});

// Get Payments
export const getPayments = () => ({
  type: 'GET_PAYMENTS'
});

// Get Credit History (merged purchases + usage ledger) — action names are namespaced as
// GET/SET_CREDIT_HISTORY_TRANSACTIONS (not GET_CREDIT_HISTORY) to avoid colliding with the
// unrelated admin-only credit history feature in store/Admin, which reuses those same action names.
export const getCreditHistoryTransactions = (payload) => ({
  payload,
  type: 'GET_CREDIT_HISTORY_TRANSACTIONS',
});

// Get Usage Metrics
export const getUsageMetrics = (payload) => ({
  payload,
  type: 'GET_USAGE_METRICS',
});

// Cancel Scheduled Plan Change
export const cancelScheduledPlanChange = (payload) => ({
  payload,
  type: 'CANCEL_SCHEDULED_PLAN_CHANGE',
});
